import { computed } from 'vue';
import { useInstanceProxy } from '@nzyme/vue';

export function useRoute() {
    const instance = useInstanceProxy();

    return computed(() => instance.$route);
}
